import { equals } from 'ramda'
import {
  createToastKey,
  shouldDeduplicateToast,
  cleanupOldToastEntriesObject,
} from 'sidecar-utilities'

export const types = {
  SET_NOTIFICATION: 'notification/SET_NOTIFICATION',
  CLEAR_NOTIFICATION_DOMAIN: 'notification/CLEAR_NOTIFICATION_DOMAIN',
  CLEAR_NOTIFICATION_ERRORS: 'notification/CLEAR_NOTIFICATION_ERRORS',
  SET_TOAST: 'notification/SET_TOAST',
  CLEAR_TOASTS: 'notification/CLEAR_TOASTS',
}

export const setNotification = note => ({
  type: types.SET_NOTIFICATION,
  payload: note,
})

export const clearNotificationDomain = domain => ({
  type: types.CLEAR_NOTIFICATION_DOMAIN,
  payload: domain,
})

export const setToast = (toast, sentiment = 'default') => ({
  type: types.SET_TOAST,
  payload: {
    content: toast,
    sentiment: sentiment,
  },
})

export const clearToasts = () => ({
  type: types.CLEAR_TOASTS,
})

export const initialState = {
  errors: [],
  // notifications are more local and don't dissapear
  notifications: [],
  // toasts are global and more temporary notifications
  toasts: [],
  // Track recent toasts for deduplication (plain object for Redux serialization)
  recentToasts: {},
}

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.SET_NOTIFICATION: {
      if (!state.notifications.find(n => equals(n, payload)))
        return {
          ...state,
          notifications: [...state.notifications, payload],
        }

      return state
    }

    case types.CLEAR_NOTIFICATION_DOMAIN: {
      return {
        ...state,
        notifications: state.notifications.filter(
          note => note.domain !== payload,
        ),
      }
    }

    case types.CLEAR_NOTIFICATION_ERRORS: {
      return {
        ...state,
        errors: [], //clear array
      }
    }

    case types.SET_TOAST: {
      // Deduplicate: Skip if same message was shown recently
      const now = Date.now()
      const toastKey = createToastKey(payload.content, payload.sentiment)

      if (shouldDeduplicateToast(state.recentToasts, toastKey, now)) {
        // Duplicate toast - skip it
        return state
      }

      // Update recent toasts tracking and clean up old entries
      const newRecentToasts = cleanupOldToastEntriesObject(
        {
          ...state.recentToasts,
          [toastKey]: now,
        },
        now,
      )

      // we don't reset the array, we just push onto it and
      // the toast will pop up.
      return {
        ...state,
        toasts: [...state.toasts, payload],
        recentToasts: newRecentToasts,
      }
    }

    case types.CLEAR_TOASTS: {
      return {
        ...state,
        toasts: [],
      }
    }

    default:
      return state
  }
}
